import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/personalInfo'
import { MENU_BAR_ACTIONS } from 'easycommons/modules/MenuBar'
import { getPersonalInfo as getPersonalInfoService, getPhoto } from 'services'

const {
  UPDATE_USER_AVATAR,
  PERSONAL_INFO_REQUEST,
  PERSONAL_INFO_REQUEST_SUCCESS,
  PERSONAL_INFO_REQUEST_ERROR
} = ACTION_TYPES

export function *getPersonalInfo() {
  try {
    const response = yield call(getPersonalInfoService)
    yield put({ type: PERSONAL_INFO_REQUEST_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: PERSONAL_INFO_REQUEST_ERROR, payload: err })
  }
}

export function *getUserAvatar() {
  const response = yield call(getPhoto)
  yield put({ type: MENU_BAR_ACTIONS.LOAD_AVATAR, payload: response })
}

export default function *watchPersonalInfo() {
  yield takeLatest(PERSONAL_INFO_REQUEST, getPersonalInfo)
  yield takeLatest(UPDATE_USER_AVATAR, getUserAvatar)
}
